import {
    ADD_MODAL_EXPORT,
    ADD_MODAL_HISTORIQUE,
    ADD_MODAL_ADDTOLIST,
    ADD_TO_LIST,
    ADD_CALCUL_RESULTAT,
    ADD_CALCUL_HISTORIQUE,
    ADD_WORK_ID,
    ADD_TO_LIST_CONDITION,
    ADD_LIST,
    ADD_ARTICLE,
    ADD_ATL_ERROR,
    ADD_CALCUL_ERROR,
    ADD_HOW_TO_LINK,
    ADD_HOW_TO_TEXT,
    ADD_WORK_TITLE,
    ADD_WORK_DESCRIPTION,
    ADD_MODAL_LOADER
} from '../../constants/ConfigFileConstants'

export default function ConfigFileReducer(state = {}, action){
    switch(action.type){
        case ADD_MODAL_LOADER:
            return {
                ...state,
                ...action.payload
            };
        case ADD_WORK_DESCRIPTION:
            return {
                ...state,
                ...action.payload
            };
        case ADD_WORK_TITLE:
            return {
                ...state,
                ...action.payload
            };
        case ADD_HOW_TO_TEXT:
            return {
                ...state,
                ...action.payload
            };
        case ADD_HOW_TO_LINK:
            return {
                ...state,
                ...action.payload
            };
        case ADD_WORK_ID:
            return {
                ...state,
                ...action.payload
            };
        case ADD_CALCUL_ERROR:
            return {
                ...state,
                ...action.payload
            };
        case ADD_ATL_ERROR:
            return {
                ...state,
                ...action.payload
            };
        case ADD_ARTICLE:
            return {
                ...state,
                ...action.payload
            };
        case ADD_LIST:
            return {
                ...state,
                ...action.payload
            };
        case ADD_TO_LIST_CONDITION:
            return {
                ...state,
                ...action.payload
            };
        case ADD_CALCUL_RESULTAT:
            return {
                ...state,
                ...action.payload
            };
        case ADD_CALCUL_HISTORIQUE:
            return {
                ...state,
                ...action.payload
            };
        case ADD_TO_LIST:
            return {
                ...state,
                ...action.payload
            };
        case ADD_MODAL_EXPORT:
            return {
                ...state,
                ...action.payload
            };
        case ADD_MODAL_HISTORIQUE:
            return {
                ...state,
                ...action.payload
            };
        case ADD_MODAL_ADDTOLIST:
            return {
                ...state,
                ...action.payload
            };
        default:
            return state
    }
}



// WEBPACK FOOTER //
// ./src/redux/reducers/ConfigFileReducer.js